import { type EuiGlobalToastListToast } from '@elastic/eui';

export const TOAST_LIFETIME_MS = 6000;

type CustomToast = Omit<EuiGlobalToastListToast, 'id'>;

let addToastHandler: (toast: CustomToast) => void;

export const setToastHandler = (handler: (toast: CustomToast) => void) => {
  addToastHandler = handler;
};

export const addErrorToast = (toast: CustomToast) => {
  addToastHandler({ ...toast, iconType: 'error', color: 'danger' });
};

export const addWarningToast = (toast: CustomToast) => {
  addToastHandler({ ...toast, iconType: 'warning', color: 'warning' });
};

export const addSuccessToast = (toast: CustomToast) => {
  addToastHandler({ ...toast, iconType: 'check', color: 'success' });
};
